import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { propsToJS } from '__utils/immutable-to-js';
import { CommonStyledComponentProps } from '__utils/type';
import PaymentViewSelector from '../payment-flow.selector';
import { useSelector } from 'react-redux';


const ChequeDetailsContainer = styled.div<CommonStyledComponentProps>`
    b{
        font-weight: 500;
        color: black;
    }
    .chalanContent div{
        color: #a1a6a7;
    }
    .text-black{
        color: black !important;
        margin-bottom: 8px;
    }
`;

const ChequeDetails: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { totalValidOrdersAmount } = propsToJS(useSelector(PaymentViewSelector));

    return (<ChequeDetailsContainer isMobile={ isMobile }>
        <div className="chalanContent">
            <div className="text-black">Fill below details in cheque from your above mentioned Bank Account </div>
            <div>
                Cheque in favour of :
                <p><b> Indian Clearing Corporation Limited</b></p>
            </div>
            <div style={ { marginTop: '8px' } }>
                Cheque amount :
                <p>{ (totalValidOrdersAmount && totalValidOrdersAmount > 0) ? <b> ₹ { totalValidOrdersAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 }) }/-</b> : <b> N.A</b> }</p>
            </div>
        </div>
    </ChequeDetailsContainer>);
};

export default ChequeDetails;

